"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormInputVariantArray = exports.FormInputSizeArray = exports.FormInputTypeArray = void 0;
var FormInputTypeArray = ['date', 'text', 'password', 'email', 'tel', 'number', 'hidden'];
exports.FormInputTypeArray = FormInputTypeArray;
var FormInputSizeArray = ['sm', 'md', 'lg'];
exports.FormInputSizeArray = FormInputSizeArray;
var FormInputVariantArray = ['default', 'line'];
exports.FormInputVariantArray = FormInputVariantArray;